<template>
    <module-card>
        <p>What a swirl of emotions!</p>
        <div v-for="emotion in emotions" :key="emotion.id">
            <p class="text-h8 text-center selected-text">{{ emotion.emotion }}</p>
            <v-slider readonly :value="choice(emotion.id)" :max="9" step="1" track-color="primary" thumb-color="red" ticks="always" tick-size="5"></v-slider>
        </div>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                emotions: [
                    {
                        id: 1,
                        emotion: 'Horny'
                    },
                    {
                        id: 2,
                        emotion: 'Guilty'
                    },
                    {
                        id: 3,
                        emotion: 'Confident'
                    },
                    {
                        id: 4,
                        emotion: 'In Love'
                    },
                    {
                        id: 5,
                        emotion: 'Loved'
                    }
                ]
            };
        },
        methods: {
            choice(id) {
                let choice = this.$store.get(`peepInLoveEmotions@${id}.choice`);

                return choice;
            }
        }
    };
</script>

<style scoped>
    ::v-deep .v-slider__tick {
        background-color: var(--v-primary-base);
    }

    .selected-text {
        white-space: pre-wrap;
    }
</style>
